<template>
  <Layout>
    <div class="content is-size-7 p-md">
      <h1 class="has-text-white is-size-3 m-b-md">{{ $t('Games in category') }} {{ $t(tag) }}</h1>
      <GameTileList :games="games" />
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/GG'
import GameTileList from '@/components/LangGG/GameTileList'

export default {
  name: 'Home',
  components: {
    Layout,
    GameTileList
  },
  data () {
    const tag = this.$route.params.name
    return {
      tag,
      games: this.$store.state.games.games.filter(game => game.tags.indexOf(tag) >= 0)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LangGG/TagPage.vue